export default async function decryptImage(base64Image) {
  return new Promise((resolve) => {
    const img = new Image();
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');

    img.onload = function () {
      const N = canvas.width = canvas.height = Math.min(img.width, img.height);
      ctx.drawImage(img, 0, 0, N, N);
      let imageData = ctx.getImageData(0, 0, N, N);
      let data = imageData.data;

      const fixedIterations = 10;
      for (let i = 0; i < fixedIterations; i++) {
        data = applyInverseArnoldCatMap(data, N);
      }

      ctx.putImageData(new ImageData(data, N, N), 0, 0);
      const decryptedBase64 = canvas.toDataURL("image/png");
      resolve(decryptedBase64);
    };

    img.src = base64Image;
  });
}

function applyInverseArnoldCatMap(data, N) {
  const newData = new Uint8ClampedArray(data.length);

  for (let x = 0; x < N; x++) {
    for (let y = 0; y < N; y++) {
      let newX = (2 * x - y + N) % N;
      let newY = (-1 * x + y + N) % N;

      let srcIndex = 4 * (y * N + x);
      let dstIndex = 4 * (newY * N + newX);
      

      newData[dstIndex] = data[srcIndex];
      newData[dstIndex + 1] = data[srcIndex + 1];
      newData[dstIndex + 2] = data[srcIndex + 2];
      newData[dstIndex + 3] = data[srcIndex + 3];
    }
  }

  return newData;
}
